import React from 'react';
import { Image, View, StyleSheet, TouchableOpacity } from 'react-native';
import { CommonProperties, Color } from '../styles';
import { HeaderButtons, Item } from 'react-navigation-header-buttons';
import CustomHeaderButton from '../components/HeaderButton';
import { Modals } from '../constants/ScreenNames';
import { DrawerActions } from '@react-navigation/native';
import { AA_ENABLED, EXPENSEPOINT_ENABLED, CREW_ENABLED } from '../config/env';
import { useSelector } from 'react-redux';
import { scale, scaleVertically } from './scale.utils';
import Avatar from '../components/Avatar';

export const noBottomBorderHeaderStyleOption = {
  headerStyle: {
    elevation: 0,
    shadowOpacity: 0,
    borderBottomWidth: 0,
  },
};

export const leftMenuHeaderOption = (props) => {
  const { userImage } = props;
  return {
    headerLeft: () => (
      <HeaderButtons HeaderButtonComponent={CustomHeaderButton}>
        {userImage ? (
          <TouchableOpacity
            style={{ margin: 5 }}
            onPress={() => {
              props.navigation.dispatch(DrawerActions.toggleDrawer());
            }}
          >
            <Avatar size={50} source={{ uri: userImage }} />
          </TouchableOpacity>
        ) : (
          <Item
            title="Menu"
            iconName="menu"
            onPress={() => {
              props.navigation.dispatch(DrawerActions.toggleDrawer());
            }}
            color={Color.primary}
          />
        )}
      </HeaderButtons>
    ),
  };
};

export const logoTitleHeaderOption = {
  headerTitle: () => (
    <View style={styles.center}>
      {(() => {
        if (AA_ENABLED) {
          return (
            <Image
              style={styles.headerLogoImg}
              source={require('../assets/img/icons/logo-aa.png')}
            />
          );
        } else if (EXPENSEPOINT_ENABLED) {
          return (
            <Image
              style={styles.headerLogoImg}
              source={require('../assets/img/logo-expensepoint.png')}
            />
          );
        } else if (CREW_ENABLED) {
          const user = useSelector((state) => state && state.auth && state.auth.user);
          const { CompanyLogoUrl } = user;
          const crewTravelImage = require('../assets/img/icons/logo-crew-travel-min.png');
          return (
            <View style={styles.headerLogocontainer}>
              {CompanyLogoUrl ? (
                <>
                  <Image style={styles.headerCompanyLogoImg} source={{ uri: CompanyLogoUrl }} />
                  <View style={styles.separator}></View>
                  <Image style={styles.headerCrewLogoImg} source={crewTravelImage} />
                </>
              ) : (
                <Image style={styles.headerCenteredLogoImg} source={crewTravelImage} />
              )}
            </View>
          );
        } else {
          return (
            <Image
              style={styles.headerLogoImg}
              source={require('../assets/img/icons/logo-home.png')}
            />
          );
        }
      })()}
    </View>
  ),
};

export const rightAgentHeaderOption = ({ navigation }) => {
  return {
    headerRight: () => (
      <HeaderButtons HeaderButtonComponent={CustomHeaderButton}>
        <Item
          title="Agent"
          iconName="agent"
          onPress={() => {
            navigation.navigate(Modals.AgentContact);
          }}
          color={Color.primary}
        />
      </HeaderButtons>
    ),
  };
};

export const rightLoginHeaderOption = (navigation) => {
  return {
    headerRight: () => (
      <HeaderButtons HeaderButtonComponent={CustomHeaderButton}>
        <Item
          title="Login"
          onPress={() => {
            navigation.navigate(Modals.AALoginScreen);
          }}
          color={Color.primary}
        />
      </HeaderButtons>
    ),
  };
};

export const rightFilterHeaderOption = (onPress, inverted) => {
  return {
    headerRight: () => (
      <HeaderButtons HeaderButtonComponent={CustomHeaderButton}>
        <Item
          title="Filters"
          iconName={inverted ? 'filterFilled' : 'filter'}
          color={Color.primary}
          onPress={onPress}
        />
      </HeaderButtons>
    ),
  };
};

export const rightUserHeaderOption = (onPress) => {
  return {
    headerRight: () => (
      <HeaderButtons HeaderButtonComponent={CustomHeaderButton}>
        <Item title="Add" iconName="addPerson" color={Color.primary} onPress={onPress} />
      </HeaderButtons>
    ),
  };
};

export const rightExpenseHeaderOption = (onPress) => {
  return {
    headerRight: () => (
      <HeaderButtons HeaderButtonComponent={CustomHeaderButton}>
        <Item title="Add Expense" iconName="filter" color={Color.primary} onPress={onPress} />
      </HeaderButtons>
    ),
  };
};

export const rightExpenseReportCardModalOption = (onPress) => {
  return {
    headerRight: () => (
      <HeaderButtons HeaderButtonComponent={CustomHeaderButton}>
        <Item title="Add Expense" iconName="clip" color={Color.primary} onPress={onPress} />
      </HeaderButtons>
    ),
  };
};

export const rightDeleteReceiptOption = (onPress) => {
  return {
    headerRight: () => (
      <HeaderButtons HeaderButtonComponent={CustomHeaderButton}>
        <Item title="Delete" iconName="trash" color={Color.primary} onPress={onPress} />
      </HeaderButtons>
    ),
  };
};

export const goHomeLeftHeaderOption = () => {
  return {
    headerLeft: () => <></>,
    // headerLeft: () => (
    //     <HeaderButtons left HeaderButtonComponent={CustomHeaderButton}>
    //       <Item
    //         title="Go Home"
    //         color={Color.primary}
    //         buttonStyle={CommonStyles.fontFamily}
    //         iconName={undefined}
    //         onPress={() => navigation.navigate(Screens.Home)}
    //       />
    //     </HeaderButtons>
    //   ),
  };
};

export const menuRootOptions = (props) => {
  return {
    ...noBottomBorderHeaderStyleOption,
    ...leftMenuHeaderOption(props),
    ...logoTitleHeaderOption,
    ...rightAgentHeaderOption(props),
  };
};

export const defaultStackHeaderOptions = {
  gestureEnabled: false,
  headerStyle: {
    backgroundColor: '#fff',
  },
  headerTintColor: Color.primary,
  headerTitleStyle: { color: 'black', ...CommonProperties.fontFamily },
  headerTitleAlign: 'center',
};

// this option is needed to maintain scroll consistency with native on web.
// it's an option to disable a web only feature to allow scrolling to hide the browser address bar
// this is a desirable feature, but it's causing our existing flex layouts to break. One way to fix this is to remove
// mode="modal" on the RootStackNavigator. This restores scrolling but leaves overflow broken on web still.
// ideally we would have mode="modal" on the RootStackNavigator anyways since it's whole purpose is to hold modals.
// For now we are using this cardStyle option to disable the ability to hide the brwoser address bar by scrolling
// as documented here. https://github.com/react-navigation/react-navigation/pull/8159
// we can reexplore enabling this feature on web when we have more time to re-evaluate the flex layout issue without this option
export const allowStackToScrollOnWebOption = {
  cardStyle: { flex: 1 },
};

export const transparentModalOptions = {
  cardStyle: { backgroundColor: 'transparent' },
  cardOverlayEnabled: true,
  cardStyleInterpolator: ({ current: { progress } }) => ({
    cardStyle: {
      opacity: progress.interpolate({
        inputRange: [0, 0.5, 0.9, 1],
        outputRange: [0, 0.25, 0.7, 1],
      }),
    },
    overlayStyle: {
      opacity: progress.interpolate({
        inputRange: [0, 1],
        outputRange: [0, 0.5],
        extrapolate: 'clamp',
      }),
    },
  }),
  headerShown: false,
};

const styles = StyleSheet.create({
  center: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerLogoImg: {
    height: 35,
    width: scale(200),
    resizeMode: 'contain',
  },
  headerCrewLogoImg: {
    height: scaleVertically(20),
    width: scale(52),
    resizeMode: 'contain',
    marginRight: scale(2),
  },
  headerCenteredLogoImg: {
    height: scaleVertically(25),
    width: scale(100),
    resizeMode: 'contain',
  },
  headerCompanyLogoImg: {
    height: scaleVertically(28),
    width: scale(100),
    resizeMode: 'contain',
  },
  headerLogocontainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: scaleVertically(30),
  },
  separator: {
    height: scaleVertically(18),
    width: scale(2),
    backgroundColor: Color.disabled,
    marginHorizontal: 5,
  },
});
